import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ff6007a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "NZGM",
  title: "NZGrapherModern",
  width: "148",
  height: "90"
}, null, -1))
const _hoisted_3 = { class: "header__content" }
const _hoisted_4 = { class: "graph-name" }
const _hoisted_5 = { class: "toolbar" }
const _hoisted_6 = ["onMouseenter"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "toolbar__menu__content"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "material-icons toolbar__menu__content__button__icon"
}
const _hoisted_11 = {
  key: 1,
  class: "toolbar__menu__content__separator"
}
const _hoisted_12 = { class: "header__controls" }
const _hoisted_13 = { class: "select" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "select__label" }, "Size", -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"0\" data-v-1ff6007a>Auto</option><option value=\"1\" data-v-1ff6007a>Auto - High Res</option><option value=\"2\" data-v-1ff6007a>Standard</option><option value=\"3\" data-v-1ff6007a>Small</option><option value=\"4\" data-v-1ff6007a>Short</option>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = { class: "select" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "select__label" }, "Graph Type", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Enter URL", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The provided URL must be a direct/raw link to a "),
  /*#__PURE__*/_createElementVNode("span", null, ".csv"),
  /*#__PURE__*/_createTextVNode(" file ")
], -1))
const _hoisted_26 = { class: "input" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input__name" }, "URL", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "graph-name__input",
            type: "text",
            placeholder: "Graph Name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.title,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolbar, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "toolbar__menu",
              key: index,
              onMouseenter: ($event: any) => (!item.action && _ctx.expand(item)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAll()))
            }, [
              _createElementVNode("button", {
                class: "toolbar__menu__button",
                onClick: ($event: any) => (_ctx.action(item))
              }, _toDisplayString(item.name), 9, _hoisted_7),
              _createVNode(_Transition, { name: "menu" }, {
                default: _withCtx(() => [
                  (item.expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (child.name)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "toolbar__menu__content__button",
                                  onClick: ($event: any) => (_ctx.action(child))
                                }, [
                                  (child.icon)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_10, _toDisplayString(child.icon), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(child.name), 1)
                                ], 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("span", _hoisted_11))
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ], 40, _hoisted_6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("select", {
            class: "select__input",
            name: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.graphData.size) = $event))
          }, _hoisted_20, 512), [
            [_vModelSelect, _ctx.graphData.size]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("select", {
            class: "select__input",
            name: "",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.graphType) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graphs, (graph, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: index,
                key: index
              }, _toDisplayString(graph.name), 9, _hoisted_23))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.graphType]
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      open: _ctx.pickURLDialog,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pickURLDialog = false))
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.importFromURL && _ctx.importFromURL(...args)))
        }, "Import"),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pickURLDialog = false))
        }, "Cancel")
      ]),
      default: _withCtx(() => [
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("label", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("input", {
            class: "input__value",
            type: "url",
            placeholder: "https://example.com/example.csv",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.importURL) = $event))
          }, null, 512), [
            [_vModelText, _ctx.importURL]
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}